export default "__VITE_ASSET__f3265628__"